import PropTypes from 'prop-types';
import React from 'react';
import { map } from 'lodash';
import Types from './TariffRatesTypes';
import { FormGroup, ControlLabel, FormControl, Grid, Row, Col } from 'react-bootstrap';
export default class TariffRatesPropsEditor extends React.Component {
    handleNameChange() {
        return (e) => {
            this.props.onChange('name', e.target.value);
        };
    }
    handleFSCChange() {
        return (e) => {
            this.props.onChange('fsc', e.target.value);
        };
    }
    handleTypeChange() {
        return (e) => {
            const type = e.target.value;
            this.props.onChange('type', type);
        };
    }
    validateName(name) {
        const length = (name) ? name.length : 0;
        if (length > 0) {
            return name;
        }
        return 'error';
    }
    render() {
        const tariffRate = this.props.tariffRate || {};
        return (React.createElement(Grid, { fluid: true },
            React.createElement(Row, { className: "show-grid" },
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, "Name"),
                        React.createElement(FormControl, { type: "text", defaultValue: tariffRate.name, onChange: this.handleNameChange(), bsStyle: this.validateName(tariffRate.name) })),
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, "FSC"),
                        React.createElement(FormControl, { type: "number", defaultValue: tariffRate.fsc, onChange: this.handleFSCChange(), bsStyle: this.validateName(tariffRate.fsc) }))),
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, "Type"),
                        React.createElement(FormControl, { componentClass: "select", defaultValue: tariffRate.type, onChange: this.handleTypeChange() }, map(Types, (type, index) => (React.createElement("option", { value: type.value, key: `type-${index}` }, type.name)))))))));
    }
}
TariffRatesPropsEditor.propTypes = {
    tariffRate: PropTypes.object,
    onChange: PropTypes.func,
};
